<!-- <footer
  class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Copyright © Global <a href="https://www.nobleui.com" target="_blank"></a>.</p>
</footer> -->


<footer class="footer ">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-12">
        <nav class="">
          <ul>
              <li>
                  <a href="https://www.pay10.ae/">
                      About Us
                  </a>
              </li>
              <!-- <li>
                  <a href="https://www.pay10.com/">
                    Social
                  </a>
              </li> -->
          </ul>
      </nav>
      </div>
      <!-- <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="pull-left">
          <ul class="text-centre">
            <li class="menu-item">
              <a href="https://www.facebook.com/pay10global/" target="_blank"><img src="./assets/image/Facebook.png" class="footer-img"  id="facebookImg"></a>
            </li>
            <li class="menu-item">
              <a href="https://www.linkedin.com/company/pay10global" target="_blank"><img src="./assets/image/LinkedIn.png" class="footer-img"  id="LinkedinImg"></a>
            </li>
            <li class="menu-item">
              <a href="https://twitter.com/Pay10_Global" target="_blank"><img src="./assets/image/Twitter.png" class="footer-img"  id="twitterImg"></a>
            </li>
            <li class="menu-item">
              <a href="https://www.instagram.com/pay10global/" target="_blank"><img src="./assets/image/Instagram.png" class="footer-img"  id="InstagramImg"></a>
            </li>
            <li class="menu-item">
              <img src="./assets/images/visa.svg" alt="Visa Logo">
            </li>
            <li class="menu-item">
              <img src="./assets/images/mastercard.svg" alt="Mastercard Logo"  class="footer-img">
            </li>
            <li class="menu-item">
              <a href="./coc.pdf" target="_blank"><img src="./assets/images/pci.svg" alt="Pci Logo"  class="footer-img" ></a>
            </li>
            <li class="menu-item">
              <a href="./ISO.pdf" target="_blank"><img src="./assets/image/ISO.png"  class="footer-img" ></a>
            </li>
          </ul>
          </div>
      </div> -->
      <div class="col-lg-10 col-md-10 col-sm-12" >  
      <div class=" pull-right">
        &copy;
        {{test | date: 'yyyy'}}, All Rights Reserved. Powered By
        <a href="https://www.pay10.com/" target="_blank"><img src="assets/images/paylogo.svg" class="mb-2 logo-height"></a> 
    </div>
      </div>
    </div>
  </div>
</footer>
